import { useState, useCallback } from 'react';

const KEY = 'seediq_fontscale_v1';

// Reader font scale (設定 · 字體大小) — mirrors the phone's fontScale in useVocab/store.
// Applied as the CSS var --fs on the app column; persisted locally.
export function useFontScale() {
  const [fontScale, setState] = useState(() => {
    const v = parseFloat(localStorage.getItem(KEY));
    return v > 0 ? v : 1;
  });
  const setFontScale = useCallback((v) => {
    setState(v);
    try { localStorage.setItem(KEY, String(v)); } catch (_) {}
  }, []);
  return [fontScale, setFontScale];
}
